import { LoanAdvertisingCopy } from 'components/domain/search/offers/loans/utils/constants'
import { Props as BlockSectionProps } from 'experiences/explore/common/sections/TrustpilotAside'
import { LoanPurposeProps } from 'experiences/explore/loans/components/NewLoanSearchWidget/LoanPurposeList'

export const crossSellData = [
	{
		title: 'Still paying down your student loans? ',
		content: 'Learn how refinancing could help you save.',
		ctaText: 'Learn more about Student Loan Refinance',
		url: '/learn/topics/student-loan-refinance'
	},
	{
		title: 'Get a life insurance policy built for you.',
		content:
			'Just answer a few questions and receive quotes from A+ rated carriers. Have questions? Our agents are just a phone call away.',
		ctaText: 'Get a quote',
		url: '/explore/life-insurance'
	},
	{
		title: 'Compare credit card offers perfect for you and your credit',
		content: "We recommend cards you're most likely to qualify for.",
		ctaText: 'Discover Credit Cards',
		url: '/explore/credit-cards'
	},
	{
		title: 'Make your money work for you',
		content: 'Compare online savings accounts and start earning interest.',
		ctaText: 'Start saving today',
		url: '/explore/savings'
	}
]

export const blockSectionProps: BlockSectionProps = {
	imgSrc: '/images/illustrations/loans-graphic.svg',
	title: 'It’s Simple, Just Search',
	text: 'Personalized loan offers in seconds — with no impact to your credit score.',
	buttonText: 'Get Started'
}

export const loanPurposeList: LoanPurposeProps[] = [
	{
		title: 'Debt Consolidation',
		icon: '/images/purpose/debt_consolidation.svg',
		loanPurpose: 'debt_consolidation'
	},
	{
		title: 'Credit Card Refinance',
		icon: '/images/purpose/credit_card_refi.svg',
		loanPurpose: 'credit_card_refi'
	},
	{
		title: 'Home Improvement',
		icon: '/images/purpose/home_improvement.svg',
		loanPurpose: 'home_improvement'
	},
	{
		title: 'Large Purchase',
		icon: '/images/purpose/large_purchases.svg',
		loanPurpose: 'large_purchases'
	},
	{
		title: 'Home Purchase',
		icon: '/images/purpose/home_purchase.svg',
		loanPurpose: 'home_purchase'
	}
]

export const heroCopy = {
	badgeText: `Rates as low as ${LoanAdvertisingCopy.LowestAPR}`,
	title: "It's fast, easy and free to search for a loan."
}
